import React, {ReactNode, useCallback, useState} from "react";
import {ATLASSIAN_PLUGIN_KEY} from "navigation-common/firebase-config";
import {ModalTransition} from "@atlaskit/modal-dialog";
import {ConfirmDialog} from "./ConfirmDialog";
import styled from "styled-components";

interface Props {
    to: string;
    children: ReactNode;
    hasIcon?: boolean;
    askConfirmation?: boolean;
    confirmTitle?: string;
    confirmMsg?: string;
    confirmBtnText?: string,
    cancelBtnText?: string,
}

export function AppLink(props: Readonly<Props>) {
    const [showConfirm, setShowConfirm] = useState(false);
    const openModal = useCallback(() => setShowConfirm(true), []);
    const closeModal = useCallback(() => setShowConfirm(false), []);

    function goto() {
        AP.navigator.go("addonModule", {
            addonKey: ATLASSIAN_PLUGIN_KEY,
            moduleKey: props.to,
        });
    }

    async function onConfirm() {
        closeModal();
        goto();
    }

    function onCancel() {
        closeModal();
    }

    function renderLinkOrIconLink() {
        if (props.hasIcon) {
            return (
                <LinkIcon onClick={() => props.askConfirmation ? openModal() : goto()} style={{}}>
                    {props.children}
                </LinkIcon>
            );
        }
        return (
            <a
                href={props.to}
                onClick={(event) => {
                    event.preventDefault();
                    goto();
                }}
            >{props.children}</a>
        );
    }

    return (
        <>
            {renderLinkOrIconLink()}
            <ModalTransition>{showConfirm &&
                <ConfirmDialog confirmMsg={props.confirmMsg} confirmTitle={props.confirmTitle} confirmBtnText={props.confirmBtnText} cancelBtnText={props.cancelBtnText}
                               onConfirm={onConfirm} onCancel={onCancel}/>}
            </ModalTransition>
        </>
    )
        ;
}

const LinkIcon = styled.a`
    padding-left: 0;
    color: inherit;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;

    &:hover {
        color: inherit;
    }
`;
